import React from 'react';

import DownloadIcon from '@mui/icons-material/Download';
import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { TEMPLATE_TYPES } from 'common/constants';

import { getDownloadOptions } from '../helpers';

import SideMenuCard from './SideMenuCard';

const DownloadCard = ({
    documentType,
    downloadFormat,
    handleClickDownload,
    isDisabled,
    isHidden,
    setDownloadFormat,
}) => {
    const { t } = useTranslation();

    const handleChange = (event) => {
        localStorage.setItem('downloadFormat', event.target.value);
        setDownloadFormat(event.target.value);
        event.preventDefault();
    };

    const options = getDownloadOptions();

    if (isHidden) return null;

    return (
        <SideMenuCard
            icon={<DownloadIcon sx={{ color: 'primary.main' }} />}
            title={t('Download', { context: 'noun' })}
        >
            <Box
                sx={{
                    alignItems: 'center',
                    display:
                        documentType === TEMPLATE_TYPES.PDF_TYPE
                            ? 'none'
                            : 'flex',
                    gap: 1,
                }}
            >
                <FormControl fullWidth sx={{ my: 2 }}>
                    <InputLabel id="format-select-label">
                        {t('Download format', { context: 'noun' })}
                    </InputLabel>
                    <Select
                        disabled={isDisabled}
                        id="demo-simple-select"
                        label="Age"
                        labelId="format-select-label"
                        onChange={handleChange}
                        value={downloadFormat}
                        variant="standard"
                        sx={{ fontSize: '0.875rem' }}
                    >
                        {options.map((option) => (
                            <MenuItem
                                key={`download-item-${option.value}`}
                                value={option.value}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <IconButton
                    color="primary"
                    disabled={isDisabled || !downloadFormat}
                    onClick={() => handleClickDownload()}
                    variant="default"
                >
                    <DownloadIcon />
                </IconButton>
            </Box>
            {documentType === TEMPLATE_TYPES.PDF_TYPE && (
                <Button
                    fullWidth
                    onClick={() => handleClickDownload()}
                    variant="outlined"
                >
                    {t('Download')}
                </Button>
            )}
        </SideMenuCard>
    );
};

DownloadCard.propTypes = {
    documentType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    downloadFormat: PropTypes.number,
    handleClickDownload: PropTypes.func,
    isDisabled: PropTypes.bool,
    isHidden: PropTypes.bool,
    setDownloadFormat: PropTypes.func,
};

export default DownloadCard;
